import Vue from 'vue'
import {DatePicker, FormItem, Form, Input, Button, Message, Select, Option, Table, Modal, Page, Spin, Icon, Checkbox, Upload} from 'view-design'
import 'view-design/dist/styles/iview.css'


Vue.component('DatePicker', DatePicker)
Vue.component('FormItem', FormItem)
Vue.component('Form', Form)
Vue.component('Input', Input)
Vue.component('Button', Button)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('Table', Table)
Vue.component('Modal', Modal)
Vue.component('Page', Page)
Vue.component('Spin', Spin)
Vue.component('Icon', Icon)
Vue.component('Checkbox', Checkbox)
Vue.component('Upload', Upload)


Vue.prototype.$Message = Message
Vue.prototype.$Modal = Modal

// console.log(Vue.prototype)